<template>
  <div class="role-card">
    <div
        :class="{ active: activeId === index }"
        class="Row"
        @click="getRoleInfo(item, index)"
        v-for="(item, index) in roleInfoList"
        :key="index"
    >
      <div class="Row-left">
        <div class="Right-sub">
          <div v-if="item.roleName" class="width_100">
            <div class="role-card-first-line">
              <div class="first-line-left">
                <svg-icon v-if="item.roleName.indexOf('管理员') > -1" class="head-portrait" icon-class="roleAdmin"/>
                <svg-icon v-else-if="item.roleName.indexOf('医生') > -1" class="head-portrait" icon-class="roleDoctor"/>
                <svg-icon v-else-if="item.roleName.indexOf('护士') > -1" class="head-portrait" icon-class="roleNurse"/>
                <svg-icon v-else class="head-portrait" icon-class="roleOther"/>
                <div class="role-card-name">
                  {{ item.roleName }}
                </div>
                <div v-if="item.roleScope === 0" class="state">系统</div>
              </div>
              <div :class="{ 'first-line-right': true, 'forbidden-style': item.status === 2 }">
                {{ item.status === 1 ? "启用" : "禁用" }}
              </div>
            </div>
            <div class="role-card-second-line">
              <div class="role-card-date">
                {{ item.createTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="roleInfoList.length == 0" class="noBottom">
      <empty></empty>
    </div>
  </div>
</template>

<script>
import empty from "../Empty"
export default {
  name: "RoleCard",
  components:{
    empty
  },
  props: {
    roleInfoList: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getRoleInfo(item, index) {
      this.$emit("updateRoleInfo", {item, index});
    }
  },
  created() {
  },
  mounted() {
  },
  filters: {}
}
</script>

<style scoped lang="less">
@surface-card: rgba(255, 255, 255, 0.05);
@border-card: rgba(255, 255, 255, 0.1);
@accent: #2ecd81;

.role-card {
  .width_100 {
    width: 100%;
  }

  .Row {
    cursor: pointer;
    padding: 16px 18px;
    min-height: 88px;
    display: flex;
    align-items: center;
    font-size: 15px;
    background: @surface-card;
    border-radius: 10px;
    border: 1px solid @border-card;
    box-sizing: border-box;
    margin-bottom: 14px;
    transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(255, 255, 255, 0.14);
    }
  }

  .Row.active {
    background: rgba(46, 205, 129, 0.14);
    border-color: rgba(46, 205, 129, 0.55);
    box-shadow: inset 4px 0 0 @accent;

    .role-card-name,
    .role-card-second-line {
      color: rgba(255, 255, 255, 0.95);
    }

    .first-line-right {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .Row-left {
    width: 100%;
    height: 100%;
    display: flex;
    align-content: center;
    flex-direction: column;
    justify-content: center;
  }

  .Right-sub {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-family: PingFang SC, "Microsoft YaHei", sans-serif;
    align-items: center;
    font-size: 14px;

    .role-card-first-line {
      display: flex;
      justify-content: space-between;
      min-height: 28px;
      line-height: 28px;
      margin-bottom: 8px;

      .first-line-left {
        display: flex;
        align-items: center;
        min-width: 0;

        svg {
          font-size: 26px;
          flex-shrink: 0;
          opacity: 0.92;
        }

        .role-card-name {
          margin-left: 14px;
          margin-right: 8px;
          font-weight: 600;
          color: rgba(255, 255, 255, 0.92);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .state {
          flex-shrink: 0;
          font-size: 12px;
          height: 22px;
          line-height: 20px;
          width: auto;
          min-width: 40px;
          padding: 0 8px;
          border-radius: 20px;
          color: rgba(255, 174, 120, 0.95);
          border: 1px solid rgba(255, 140, 80, 0.35);
          background: rgba(255, 107, 0, 0.12);
        }
      }

      .first-line-right {
        flex-shrink: 0;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.5);
      }

      .forbidden-style {
        color: rgba(255, 159, 120, 0.95);
      }
    }

    .role-card-second-line {
      .role-card-date {
        margin-left: 40px;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.38);
      }
    }
  }

  .noBottom {
    text-align: center;
    padding: 40px 0 24px;
    color: rgba(255, 255, 255, 0.35);
    font-size: 13px;
  }
}
</style>
